import { useAuthorization } from '@/features/auth/context/authorization';

/**
 * Comprehensive authorization hook.
 * Provides all permission and role checking methods in one place.
 * Use this when you need multiple checks in a single component.
 */
export function useAuthorize() {
  const auth = useAuthorization();

  return {
    // State
    roles: auth.roles,
    permissions: auth.permissionNames,
    isLoaded: auth.isLoaded,
    isLoading: auth.isLoading,
    error: auth.error,

    // Actions
    refresh: auth.refresh,

    // Permission checks
    can: auth.can,
    cannot: auth.cannot,
    hasPermission: auth.hasPermission,
    hasAnyPermission: auth.hasAnyPermission,
    hasAllPermissions: auth.hasAllPermissions,

    // Role checks
    hasRole: auth.hasRole,
    hasAnyRole: auth.hasAnyRole,
    hasAllRoles: auth.hasAllRoles,
    isSuperAdmin: auth.isSuperAdmin,
  };
}
